import { ChangeDetectionStrategy, Component } from '@angular/core';


@Component({
    selector: 'shared-coming-soon',
    imports: [],
    templateUrl: './coming-soon.component.html',
    styleUrl: './coming-soon.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ComingSoonComponent {

}
